import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  mode: 'history', // fix /#/
  routes: [
    { path: '/', component: () => import('./Home/index.vue') },
    { path: '/login', component: () => import('./login.vue') },
    { path: '/note', component: () => import('./todo.vue') },
    { path: '/diary', component: () => import('./diary.vue') },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js